export const FETCH_REQUIREMENTS_LIST = 'REQUIREMENT/fetch_requirements_list';

export const GET_REQUIREMENT_LIST = 'REQUIREMENT/GET_REQUIREMENT_LIST';
export const UPDATE_APPLICATION_REQUIREMENT = 'REQUIREMENT/UPDATE_APPLICATION_REQUIREMENT';
export const GET_SETTINGS = 'APPLCIATION_SETTINGS/get_settings';